import { createFileRoute } from "@tanstack/react-router";
import AdminHeroMessaging from "@/pages/admin/AdminHeroMessaging";

export const Route = createFileRoute("/admin/hero-messaging")({ component: AdminHeroMessaging });
